// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-banner-carousel-item {
  background-color: white;
}
.hero-banner-carousel-item img {
  min-height: 260px;
  object-fit: cover;
}
.content-tab-group img {
  max-width: 100%;
}
._1gq4l610 p {
  margin-bottom: 0;
}
._1gq4l612 {
  display: flex;
  width: 100%;
}
._1gq4l613 {
  width: 100%;
  padding: 8px;
  height: 100%;
  white-space: normal;
}
._1gq4l615 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 54px;
  padding-left: 20px;
  padding-right: 20px;
  height: 36px;
}
._1gq4l616 {
  padding: 12px;
  width: 120px;
  font-size: 16px;
  font-weight: 600;
}
._1gq4l617 {
  margin-right: 0px;
  flex-direction: column;
  background-color: white;
  padding: 16px;
  width: 100%;
}
._1gq4l618 {
  margin-bottom: 16px;
}
._1gq4l619 {
  gap: 20px;
  display: flex;
  align-items: stretch;
}
._1gq4l61a {
  align-self: center;
  margin-top: auto;
  width: var(--_18w76bw1w);
  max-width: var(--_18w76bw1e);
}
._1gq4l61b {
  background-color: var(--_18w76bw25);
  padding: var(--_18w76bwg) var(--_18w76bwi);
}
@media screen and (min-width: 769px) {
  ._1gq4l611 {
    width: calc((100% - 28px * 2 -20px * 2) / 3);
    height: auto;
  }
}
@media screen and (max-width: 768px) {
  ._1gq4l611 {
    width: 100%;
    height: auto;
  }
  ._1gq4l619 {
    flex-direction: column;
  }
}
@media screen and (min-width: 768px) {
  ._1gq4l612 {
    flex: 1;
    max-width: initial;
  }
  ._1gq4l614 {
    overflow: auto;
    flex: none;
    flex-flow: nowrap;
  }
  ._1gq4l615 {
    bottom: 51px;
  }
  ._1gq4l617 {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-right: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE;IACE,4CAA4C;IAC5C,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,OAAO;IACP,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".hero-banner-carousel-item {\n  background-color: white;\n}\n.hero-banner-carousel-item img {\n  min-height: 260px;\n  object-fit: cover;\n}\n.content-tab-group img {\n  max-width: 100%;\n}\n._1gq4l610 p {\n  margin-bottom: 0;\n}\n._1gq4l612 {\n  display: flex;\n  width: 100%;\n}\n._1gq4l613 {\n  width: 100%;\n  padding: 8px;\n  height: 100%;\n  white-space: normal;\n}\n._1gq4l615 {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 54px;\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 36px;\n}\n._1gq4l616 {\n  padding: 12px;\n  width: 120px;\n  font-size: 16px;\n  font-weight: 600;\n}\n._1gq4l617 {\n  margin-right: 0px;\n  flex-direction: column;\n  background-color: white;\n  padding: 16px;\n  width: 100%;\n}\n._1gq4l618 {\n  margin-bottom: 16px;\n}\n._1gq4l619 {\n  gap: 20px;\n  display: flex;\n  align-items: stretch;\n}\n._1gq4l61a {\n  align-self: center;\n  margin-top: auto;\n  width: var(--_18w76bw1w);\n  max-width: var(--_18w76bw1e);\n}\n._1gq4l61b {\n  background-color: var(--_18w76bw25);\n  padding: var(--_18w76bwg) var(--_18w76bwi);\n}\n@media screen and (min-width: 769px) {\n  ._1gq4l611 {\n    width: calc((100% - 28px * 2 -20px * 2) / 3);\n    height: auto;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._1gq4l611 {\n    width: 100%;\n    height: auto;\n  }\n  ._1gq4l619 {\n    flex-direction: column;\n  }\n}\n@media screen and (min-width: 768px) {\n  ._1gq4l612 {\n    flex: 1;\n    max-width: initial;\n  }\n  ._1gq4l614 {\n    overflow: auto;\n    flex: none;\n    flex-flow: nowrap;\n  }\n  ._1gq4l615 {\n    bottom: 51px;\n  }\n  ._1gq4l617 {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-right: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
